module.exports = __webpack_public_path__ + "static/media/ball_3_3.882ea6e2.mp3";